import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { Icon, IconButton, Tooltip, useTheme } from '../../../../../../base';
import {
    StyledDragHandle,
    StyledDragHandleWrapper,
    StyledActionButtonsMobile,
} from '../../JobQuestions.styles';
import { useTranslation } from 'react-i18next';

interface QuestionHeaderProps {
    attributes: DraggableAttributes;
    listeners: SyntheticListenerMap | undefined;
    onCopy: () => void;
    onDelete: () => void;
}

export const QuestionHeader = ({
    attributes,
    listeners,
    onCopy,
    onDelete,
}: QuestionHeaderProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <>
            {/* Drag Handle */}
            <StyledDragHandleWrapper>
                <StyledDragHandle {...attributes} {...listeners}>
                    <Icon
                        name="DragIndicatorIcon"
                        sx={{ color: theme.palette.text.secondary }}
                    />
                </StyledDragHandle>
            </StyledDragHandleWrapper>

            {/* Action Icons - Mobile (absolutely positioned) */}
            <StyledActionButtonsMobile>
                <Tooltip title={t('saveJob.copyQuestion')}>
                    <IconButton
                        onClick={onCopy}
                        size="small"
                        aria-label={t('saveJob.copyQuestion')}
                        sx={{ padding: '4px' }}
                    >
                        <Icon name="ContentCopyOutlinedIcon" sx={{ fontSize: 20 }} />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('saveJob.deleteQuestion')}>
                    <IconButton
                        onClick={onDelete}
                        size="small"
                        aria-label={t('saveJob.deleteQuestion')}
                        sx={{ padding: '4px' }}
                    >
                        <Icon name="DeleteIcon" sx={{ fontSize: 20 }} />
                    </IconButton>
                </Tooltip>
            </StyledActionButtonsMobile>
        </>
    );
};

